var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 25.8261,
    rx: 12.913,
    fill: "#D3D905"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1038",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 14,
    height: 15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5.91309,
    width: 14,
    height: 14,
    fill: "#261D1D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.55566 19.1349V8.63493C7.55566 8.3141 7.6699 8.03944 7.89837 7.81097C8.12684 7.5825 8.4015 7.46826 8.72233 7.46826H18.0557C18.3765 7.46826 18.6512 7.5825 18.8796 7.81097C19.1081 8.03944 19.2223 8.3141 19.2223 8.63493V15.6349C19.2223 15.9558 19.1081 16.2304 18.8796 16.4589C18.6512 16.6874 18.3765 16.8016 18.0557 16.8016H9.889L7.55566 19.1349ZM9.39316 15.6349H18.0557V8.63493H8.72233V16.2912L9.39316 15.6349Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.cefba33a0aae940526dcace0c5c39a2f.svg";
export { ForwardRef as ReactComponent };